import { useFetchCategoriesQuery } from '@api/Trinium/Endpoints/JobCategories/slice';
import { JobCategory } from '@api/Trinium/Endpoints/JobCategories/types';
import useCurrentTerminal from '@hooks/useCurrentTerminal';
import { Field, FieldProps, useFormikContext } from 'formik';
import { Autocomplete, TextField } from '@mui/material';

interface JobCategoryFieldProps {
	fieldName: string;
	className?: string;
	disabled?: boolean;
}

export default function JobCategoryMultiSelectField(props: JobCategoryFieldProps) {
	const { getFieldMeta, setFieldValue } = useFormikContext();
	const { value } = getFieldMeta<JobCategory[]>(props.fieldName);
	const { number: terminalNumber } = useCurrentTerminal();

	const { data: categories } = useFetchCategoriesQuery({
		terminalNumber: terminalNumber
	});

	return (
		<Field name={props.fieldName}>
			{({ field }: FieldProps) => (
				<Autocomplete<JobCategory, true>
					{...field}
					multiple
					options={categories || []}
					value={value}
					onChange={(_, newValue) => {
						void setFieldValue(props.fieldName, newValue, true);
					}}
					getOptionLabel={(option) => `${option.id} - ${option.name}`}
					isOptionEqualToValue={(option, value) => option.id === value.id}
					className={props.className}
					fullWidth
					renderInput={(params) => (
						<TextField
							{...params}
							label='Job Categories'
							variant='standard'
							multiline
							fullWidth
						/>
					)}
				/>
			)}
		</Field>
	);
}
